import { Address, isAddress } from 'viem'
import { z } from 'zod'

const address = z.custom<Address>((val) => typeof val === 'string' && isAddress(val))

export const treasuryTransferSchema = z.object({
    recipient: address,
    currency: address,
})

export type TreasuryTransferSchema = z.infer<typeof treasuryTransferSchema>
